export default __webpack_public_path__ + "static/media/pen_rename.4b98161c.svg";